import loadable from '@loadable/component';

export const OrgDashboardViewAllVolunteersPageLoadable = loadable(
  () => import('./OrgDashboardViewAllVolunteersPage'),
  {
    resolveComponent: (module) => module.OrgDashboardViewAllVolunteersPage,
    ssr: false,
  },
);
